export const GUI_PANEL_GENERAL = 0
export const GUI_PANEL_PBR = 1
export const GUI_PANEL_UNLIT = 2
export const GUI_PANEL_CUSTOM = 3